import _ from 'lodash'
const selectList = {
  props: {
    backDatas: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectList: []
    }
  },
  watch: {
    visible(open) {
      if (open) {
        this.selectList = [...this.backDatas]
      }
    }
  },
  methods: {
    handleTagAdd(item) {
      if (this.multiple) {
        const index = _.findIndex(this.selectList, { id: item.id })
        if (index < 0) {
          this.selectList.push(item)
        }
      } else {
        this.selectList = [item]
      }
    },
    handleTagRemove(item) {
      const index = _.findIndex(this.selectList, { id: item.id })
      if (index >= 0) {
        this.selectList.splice(index, 1)
      }
    },
    handleToggle(item) {
      if (this.multiple) {
        const index = _.findIndex(this.selectList, { id: item.id })
        if (index >= 0) {
          this.selectList.splice(index, 1)
        } else {
          this.selectList.push(item)
        }
      } else {
        this.selectList = [item]
      }
    },
    handleAll(allItems, checkAll) {
      if (checkAll) {
        allItems.map(item => {
          const index = _.findIndex(this.selectList, { id: item.id })
          if (index < 0) {
            this.selectList.push(item)
          }
        })
      } else {
        allItems.map(item => {
          const index = _.findIndex(this.selectList, { id: item.id })
          if (index >= 0) {
            this.selectList.splice(index, 1)
          }
        })
      }
    }
  }
}

export default selectList
